import type { EmployeeAddition } from './employee-addition.type.ts';
export interface EmployeeAdditionExtension extends EmployeeAddition {}
export class EmployeeAdditionExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get editableMergedFields() {
    const mergedData = this.processed.merged || {};
    const result: Record<string, unknown> = {};
    // Remove the fields that are not needed
    for (const [key, value] of Object.entries(mergedData)) {
      if (
        ![
          'payrollId',
          'id',
          'isActive',
          'createdAt',
          'updatedAt',
          'role',
          'contributionAmount',
          'contributionPlanKey',
        ].includes(key)
      ) {
        result[key] = value;
      }
    }

    return result;
  }

  get allAttributes() {
    return {
      raw: this.raw,
      fields: this.processed.fields,
      merged: this.processed.merged,
      hashKeys: this.processed.hashKeys,
      overrides: this.overrides,
    };
  }
}

const Registration = {
  kind: 'object',
  name: 'employee-addition',
  features: EmployeeAdditionExtension,
};
export default Registration;
